var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlPayMonthlyIconsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon example "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.33047 8.75573V7.41406H7.67213V8.75573H6.33047ZM3.99714 8.75573V7.41406H5.3388V8.75573H3.99714ZM8.6638 8.75573V7.41406H10.0055V8.75573H8.6638ZM6.33047 11.0891V9.7474H7.67213V11.0891H6.33047ZM3.99714 11.0891V9.7474H5.3388V11.0891H3.99714ZM8.6638 11.0891V9.7474H10.0055V11.0891H8.6638ZM1.38672 13.6995V2.16406H3.57422V1.28906H4.77005V2.16406H9.23255V1.28906H10.4284V2.16406H12.6305V13.6995H1.38672ZM2.75755 12.3286H11.2451V6.18906H2.75755V12.3286ZM2.75755 5.31406H11.2451V3.54948H2.75755V5.31406ZM2.75755 5.31406V3.54948V5.31406Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlPayMonthlyIconsvg);
export default __webpack_public_path__ + "static/media/bl-pay-monthly-icon.svg.01245e0d6fb3ed94995e714cd473b94c.svg";
export { ForwardRef as ReactComponent };